import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CommentEditPage } from './comment-edit';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../shared/shared.module';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    CommentEditPage,
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(CommentEditPage),
    TextMaskModule,
    SharedModule,
  ],
})
export class CommentEditPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/comments/comment-edit/comment-edit.module.ts